import React from 'react';
import './AboutUsTeam.css';

const AboutUsTeam = () => {
  const teamMembers = [
    { name: "Bijan Burnard", position: "Co Founder", photo: "/founder.jpeg" },
     { name: "Jonathan Mileshik", position: "Co Founder", photo: "/e-vice-president-gas.jpeg" },
   
    { name: "Brad McGann", position: "Executive AI Operations", photo: "/e-vice-president.png" },
    { name: "Cyril Leroy", position: "Executive D-AI Security", photo: "/e-vice-president-cloud.png" },
   
    { name: "Joshua Pelkin", position: "Executive Hardware Development", photo: "/e-vice-president-ts.png" },
     { name: "Hatim Daudi", position: "Executive Technology Development", photo: "/Hatim-Daudi.jpg" },
     
     
  ];

  return (
    <section className="team-section" id="team">
        <div className="container">
      <div className="team-container">
        <div className="team-header">
          <h2 className="team-title">OUR EXPERT <span className='blue-text'>TEAM</span></h2>
          <p className="team-pun">
            We excel at what we do, and we love every line of code of it! (pun intended)
          </p>
        </div>
        
        <div className="team-description">
          <p>
           Over the last 5 years, Lattice Labs has grown to employ the top 1% of talent—more than 100 dedicated, EU-based professionals who align your business goals with advanced tech solutions. Recognized for our elite delivery processes, our team of web developers, designers, product managers, and data scientists combines technical expertise, creativity, and vision to craft bespoke web and app software that accelerates your digital journey.
          </p>
        </div>

        <div className="management-team">
          <h3 className="management-title">MANAGEMENT TEAM</h3>
          
          <div className="team-members">
            {teamMembers.map((member, index) => (
              <div className="team-member" key={index}>
                <div className="member-photo-container">
                  <img 
                    src={member.photo} 
                    alt={`${member.name}, ${member.position}`}
                    className="member-photo"
                  />
                </div>
                <h4>{member.name}</h4>
                <p>{member.position}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default AboutUsTeam;